import React, { CSSProperties } from 'react';

const KariusK = React.forwardRef<HTMLDivElement, { style?: CSSProperties; className?: string; fill?: string }>(
  ({ fill, ...props }, ref) => {
    return (
      <div ref={ref} {...props}>
        <svg width='22' height='29' viewBox='0 0 22 29' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <path
            d='M20.5995 0.687604C19.6349 -0.235071 17.9784 -0.182246 17.0718 0.798537L4.99135 13.8859V2.54C4.99135 1.86635 4.72841 1.22029 4.26038 0.743948C3.79235 0.267606 3.15757 0 2.49567 0C1.83378 0 1.199 0.267606 0.730966 0.743948C0.262936 1.22029 0 1.86635 0 2.54V26.4582C0 27.1319 0.262936 27.7779 0.730966 28.2543C1.199 28.7306 1.83378 28.9982 2.49567 28.9982C3.15757 28.9982 3.79235 28.7306 4.26038 28.2543C4.72841 27.7779 4.99135 27.1319 4.99135 26.4582V21.306L20.7111 4.2797C21.1614 3.78685 21.4023 3.13297 21.3814 2.46028C21.3605 1.7876 21.0795 1.15051 20.5995 0.687604Z'
            fill={fill ?? 'white'}
          />
          <path
            d='M21.3045 24.6966L15.3063 18.4456C14.3651 17.4772 12.7224 17.4772 11.7734 18.4316C11.3047 18.906 11.0399 19.5502 11.037 20.223C11.0341 20.8958 11.2933 21.5423 11.7578 22.021L17.7042 28.2235C17.9293 28.4729 18.201 28.6739 18.5035 28.8149C18.806 28.9558 19.1331 29.0339 19.4656 29.0444C19.7982 29.0549 20.1294 28.9977 20.4399 28.8762C20.7504 28.7546 21.0339 28.5711 21.2738 28.3365C21.5137 28.1019 21.7051 27.8208 21.8367 27.5099C21.9684 27.1989 22.0377 26.8643 22.0406 26.5258C22.0434 26.1872 21.9798 25.8514 21.8534 25.5382C21.727 25.225 21.5404 24.9407 21.3045 24.7019'
            fill={fill ?? 'white'}
          />
        </svg>
      </div>
    );
  },
);

KariusK.displayName = 'KariusK';

export default KariusK;
